module.exports = __webpack_public_path__ + "img/DSImage1.1f476ffa.png";